import React, { Component } from "react";
import { Modal, Form, Input, InputNumber, Select } from "antd";
import { inject, observer } from "mobx-react";
import co from "co";

const FormItem = Form.Item;
const Option = Select.Option;

@Form.create({
	mapPropsToFields(props) {
		return props.fields;
	}
})
class AddEditLinkSetProfileForm extends Component {
	validateForm = callback => {
		this.props.form.validateFieldsAndScroll(callback);
	};

	getValues = () => {
		return {
			linkSetId: this.props.form.getFieldValue("linkSetId"),
			linkProb: this.props.form.getFieldValue("linkProb"),
			minLinks: this.props.form.getFieldValue("minLinks"),
			maxLinks: this.props.form.getFieldValue("maxLinks")
		};
	};

	linksValidator = (rule, value, callback) => {
		// console.log("Validating", value);
		if (value == null || value == undefined) {
			callback("Required");
		}
		let minLinks = this.props.form.getFieldValue(`minLinks`);
		let maxLinks = value;
		if (minLinks > maxLinks) {
			callback("Max links must be greater or equal to min links");
			return;
		} else {
			callback();
		}
	};

	render() {
		const urlLists = this.props.urlLists;
		return (
			<Form layout="vertical">
				<FormItem label="Link Set">
					{this.props.form.getFieldDecorator("linkSetId", {
						rules: [
							{
								required: true,
								message: "Please select a link set"
							}
						]
					})(
						<Select
							style={{ width: "100%" }}
							placeholder="Please select a link set"
						>
							{urlLists.map(urlList => {
								return (
									<Option key={urlList.id} value={urlList.id}>
										{urlList.name}
									</Option>
								);
							})}
						</Select>
					)}
				</FormItem>
				<FormItem label="Min Number of Links per Post">
					{this.props.form.getFieldDecorator("minLinks", {
						rules: [
							{
								required: true,
								type: "integer",
								min: 0,
								max: 20,
								message: "Must be a number between 0 and 20"
							}
						]
					})(<InputNumber min={0} max={20} type="text" />)}
				</FormItem>
				<FormItem label="Max Number of Links per Post">
					{this.props.form.getFieldDecorator("maxLinks", {
						rules: [
							{
								required: true,
								type: "integer",
								min: 0,
								max: 20,
								message:
									"Must be a number between 0 and 20 and greater or equal to min links",
								validator: this.linksValidator
							}
						]
					})(<InputNumber min={0} max={20} type="text" />)}
				</FormItem>
				<FormItem label="Percentage of Posts having Links">
					{this.props.form.getFieldDecorator("linkProb", {
						rules: [
							{
								required: true,
								type: "integer",
								min: 1,
								max: 100,
								message: "Must be a number between 0 and 100"
							}
						]
					})(<InputNumber min={0} max={100} type="text" />)}
				</FormItem>
			</Form>
		);
	}
}

@inject("rootStore")
@observer
export default class AddEditLinkSetProfileDialog extends Component {
	validateForm = () => {
		return new Promise(resolve => {
			this.internalForm.validateForm((err, vals) => {
				resolve(err);
			});
		});
	};

	mapPropsToFields = () => {
		const {
			rootStore: { privateProjectStore }
		} = this.props;
		const ui = privateProjectStore.ui;

		let linkSetProfile = ui.linkSetProfile;

		if (linkSetProfile == null) {
			return {
				linkSetId: Form.createFormField({
					value: null
				}),
				linkProb: Form.createFormField({
					value: null
				}),
				minLinks: Form.createFormField({
					value: 1
				}),
				maxLinks: Form.createFormField({
					value: 3
				})
			};
		}

		return {
			linkSetId: Form.createFormField({
				value: linkSetProfile.linkSetId
			}),
			linkProb: Form.createFormField({
				value: linkSetProfile.linkProb
			}),
			minLinks: Form.createFormField({
				value: linkSetProfile.minLinks
			}),
			maxLinks: Form.createFormField({
				value: linkSetProfile.maxLinks
			})
		};
	};

	saveLinkSet = () => {
		co(
			function*() {
				const response = yield this.validateForm();
				if (response != null) return;
				const {
					rootStore: { privateProjectStore }
				} = this.props;
				const urlLists = privateProjectStore.urlLists;
				let linkSetProfile = this.internalForm.getValues();
				for (let urlList of urlLists) {
					if (urlList.id == linkSetProfile.linkSetId) {
						linkSetProfile.name = urlList.name;
					}
				}

				privateProjectStore.addLinkSetProfile(linkSetProfile);
			}.bind(this)
		);
	};

	hideDialog = () => {
		const {
			rootStore: { privateProjectStore }
		} = this.props;

		privateProjectStore.hideAddEditLinkSetProfileDialog();
	};

	render() {
		const {
			rootStore: { privateProjectStore }
		} = this.props;

		const ui = privateProjectStore.ui;
		const linkSetProfile = privateProjectStore.ui.linkSetProfile;
		const linkSetProfiles = privateProjectStore.stateForm.linkSetProfiles;
		const urlLists = privateProjectStore.urlLists.filter(urlList => {
			if (linkSetProfile && urlList.id == linkSetProfile.linkSetId) {
				return true;
			}
			if (
				linkSetProfiles.findIndex(linkSetProfile => {
					return linkSetProfile.linkSetId == urlList.id;
				}) == -1
			) {
				return true;
			} else {
				return false;
			}
		});

		return (
			<Modal
				visible={ui.addEditLinkSetProfileDialogVisible}
				title="Link Set Profiles"
				okText="Save"
				onCancel={this.hideDialog}
				onOk={this.saveLinkSet}
			>
				<AddEditLinkSetProfileForm
					fields={this.mapPropsToFields()}
					urlLists={urlLists}
					wrappedComponentRef={internalForm => {
						this.internalForm = internalForm;
					}}
				/>
			</Modal>
		);
	}
}
